import { Grid, Link } from "@mui/material";
import React, { useState } from "react";
import "./Components.css";
import ConfirmDialog from "./ConfirmDialog";
import { useNavigate } from 'react-router-dom';

const Header = () => {

    const navigate = useNavigate();

    const [openDialog, setOpenDialog] = useState(false);

    const onLogout = () => {
        localStorage.clear();
        navigate('/login');
    }

    return (
        <Grid
            container
            sx={{
                display: "flex",
                minWidth: "90vw",
                padding: "1rem",
                backgroundColor: "#1976d2",
                color: "#ffffff",
                display: "flex",
                alignItems: "center",
            }}
        >
            <Grid sx={6} md={3}>
                <img
                    src='https://www.naturalpackersandmovers.com/wp-content/uploads/2024/05/NPM-Logo.png'
                    className='logo'
                />
            </Grid>
            <Grid sx={6} md={9} display='flex'>
                <Grid xs={2} ml={2}>
                    <Link href='/manage' underline='hover' color='inherit'>
                        Manage List
                    </Link>
                </Grid>
                <Grid xs={2}>
                    <Link href='/list' underline='hover' color='inherit'>
                        Orders
                    </Link>
                </Grid>
                <Grid
                    xs={2}
                    sx={{ marginLeft: "auto", cursor: "pointer" }}
                    onClick={() => setOpenDialog(true)}
                >
                    Logout
                </Grid>
            </Grid>
            <ConfirmDialog
                open={openDialog}
                handleCancel={() => {
                    setOpenDialog(false);
                }}
                message={"Are you sure you want to logout?"}
                handleAccept={onLogout}
            />
        </Grid>
    );
};

export default Header;
